import { FC, useState } from "react";
import { Grid, Box, Menu, MenuItem, FormGroup, Checkbox, Button } from "@mui/material";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import LoadingButton from "@mui/lab/LoadingButton";
import { ApiStatus } from "../../utils/api.types";
import { useAppSelector } from "../../store/hooks";

interface CreditNoteButtonsProps {
  type: string;
  selectedSend: (data: any) => void;
  invoiceStatus: string;
  onCancel: () => void;
}

const initialState = {
  email: false,
  sms: false,
  whatsapp: false,
};

// PatTo component
const DebitNoteButtons: FC<CreditNoteButtonsProps> = ({type, selectedSend, invoiceStatus, onCancel}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { status } = useAppSelector(state => state.creditNotes);
  // const { status } = useAppSelector(state => state.invoices);
  const open = Boolean(anchorEl);
  const [state, setState] = useState(initialState);
  const { email, sms, whatsapp } = state;
  const [isApiCalled, setIsApiCalled] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };

  const handleClick = (event: any) => {
    setState(initialState);
    setAnchorEl(event.currentTarget);
    if(type ==='account-payable') {
      handleClose();
    }
  }

  const handleClose= () => {
    selectedSend(state)
    setAnchorEl(null);
  }

  return (
    <>
      <Grid container style={{ padding: 0, justifyContent: 'space-between' }}>
        <Grid item md={12} xs={12} style={{ position: 'fixed', bottom: 0, right: 0, zIndex: '999', background: '#FFF', width: 'inherit' }}>
          <Box sx={{ display: "flex", justifyContent: "end", columnGap: 2, mr: '37px', }} >
            {/* <Button className={'buttonRoot'} variant="outlined" onClick={() => window.location.reload()}>
              Cancel
            </Button> */}
            <Button className={'buttonRoot'} variant="outlined" onClick={onCancel}>
              Cancel
            </Button>

            <LoadingButton
              className={'buttonContainedRoot'}
              onClick={handleClick}
              variant="contained"
              loading={status === ApiStatus.LOADING}
              // loading={isApiCalled}
            >
              {type ==='account-payable' ? 
                'Save' : 
                <>Save & Send <KeyboardArrowUpIcon style={{ cursor: 'pointer' }} fontSize="small" /></>
              }
            </LoadingButton>
            {type ==='sale-debit-note' && (
              <Menu
                id="menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => { setAnchorEl(null); }}
                keepMounted
                disableScrollLock={true}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <FormGroup>
                  <MenuItem key={'email'}><Checkbox checked={email} onChange={handleChange} name='email' /> {'Email'}</MenuItem>
                  <MenuItem key={'sms'}><Checkbox checked={sms} onChange={handleChange} name='sms' disabled/> {'SMS'}</MenuItem>
                  <MenuItem key={'whatsapp'}><Checkbox checked={whatsapp} onChange={handleChange} name='whatsapp' disabled /> {'WhatsApp'}</MenuItem>
                </FormGroup>
                <Button style={{ display: 'flex', margin: '0 auto' }} className={'buttonContainedRoot'} variant="contained" onClick={handleClose}>
                  Dispatch
                </Button>
              </Menu>
            )}

            {
              <LoadingButton
                className={'buttonContainedRoot'}
                type="submit"
                name={'submit'}
                loading={status === ApiStatus.LOADING}
                // loading={isApiCalled}
                // disabled={!methods.formState.isValid}
                variant="contained"
                // onClick={handleClose}
              >
                {"Save as Draft"}
              </LoadingButton>
            }
          </Box>
        </Grid>
      </Grid>
  </>
  );

};

export default DebitNoteButtons;